import {createContext} from 'react';

export const MediaContext = createContext({});
